module.exports = __webpack_public_path__ + "img/44914992003749.acf97829.png";